import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import intervalPlural from "i18next-intervalplural-postprocessor";
import { defaultLanguage, supportedLanguages } from "./locales/config";
import Cze from "./locales/login.lemonero.cze.json";
import Eng from "./locales/login.lemonero.eng.json";
import Svk from "./locales/login.lemonero.svk.json";
export var defaultNS = "ns1";
export var resources = {
    en: {
        ns1: Eng,
    },
    cs: {
        ns1: Cze,
    },
    sk: {
        ns1: Svk,
    },
};
i18n.use(intervalPlural).use(initReactI18next).init({
    supportedLngs: supportedLanguages,
    fallbackLng: defaultLanguage,
    defaultNS: defaultNS,
    resources: resources,
    debug: true,
});
//# sourceMappingURL=i18n.js.map